import { Box, Card } from "@mui/material";
import { styled } from "@mui/material/styles";
import Image from "src/components/Image";
import useResponsive from "src/hooks/useResponsive";
import LoginBanner from "src/images/login.webp";
import Logo from "../../../../components/Logo";

const ImageCard = () => {
  const mdUp = useResponsive("up", "md");

  return (
    mdUp && (
      <SectionStyle>
        <Box sx={{ width: "100%", mb: 5 }}>
          <Logo style={{ placeSelf: "center" }} />
        </Box>
        <Image visibleByDefault disabledEffect alt="login" src={LoginBanner} />
      </SectionStyle>
    )
  );
};

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 564,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2),
}));

export default ImageCard;
